var React = require('react');

function SocialFacebook (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Facebook"),React.createElement("g",{"fill":"none","key":1},[React.createElement("path",{"fill":"#ffffff","d":"M0 0h88v88h-88z","key":0}),React.createElement("path",{"d":"M46.459 61v-15.487h5.221l.782-6.062h-6.003v-3.861c0-1.751.486-2.944 2.997-2.944h3.182v-5.407c-.554-.074-2.453-.238-4.663-.238-4.615 0-7.773 2.816-7.773 7.989v4.461h-5.202v6.062h5.202v15.487h6.258z","fill":"#4267b2","fillRule":"nonzero","key":1})])]);
}

SocialFacebook.defaultProps = {"viewBox":"0 0 88 88"};

module.exports = SocialFacebook;

SocialFacebook.default = SocialFacebook;
